export default __webpack_public_path__ + "static/media/q27_step6.369c2906.png";